import { FormField, FormRenderTypes } from "../Shared/Components/FormRenderer";
import { FormRenderGroupTypes } from "../Shared/Components/FormRenderer/FormRenderGroup.types";

export const hotelFields: FormField[] = [
  {
    name: 'name',
    label: 'Nazwa hotelu',
    type: FormRenderTypes.input,
    value: '',
    placeholder: 'Wprowadź nazwę hotelu',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'shortDescription',
    label: 'Krótki opis',
    type: FormRenderTypes.input,
    value: '',
    placeholder: 'Wprowadź krótki opis hotelu',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'description',
    label: 'Opis',
    type: FormRenderTypes.wysiwyg,
    value: '',
    placeholder: 'Opis hotelu',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'location',
    label: 'Położenie',
    type: FormRenderTypes.wysiwyg,
    value: '',
    placeholder: 'Opis położenia hotelu',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'amenities',
    label: 'Do dyspozycji',
    type: FormRenderTypes.wysiwyg,
    value: '',
    placeholder: 'Udogodnienia i wyposażenie hotelu',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'accommodation',
    label: 'Zakwaterowanie',
    type: FormRenderTypes.wysiwyg,
    value: '',
    placeholder: 'Opis zakwaterowania',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'meals',
    label: 'Wyżywienie',
    type: FormRenderTypes.wysiwyg,
    value: '',
    placeholder: 'Opis wyżywienia',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'slug',
    label: 'Przyjazna nazwa dla wyszukiwarek',
    type: FormRenderTypes.input,
    value: '',
    placeholder: 'Przyjazna nazwa dla wyszukiwarek',
    group: FormRenderGroupTypes.seo,
  },
  {
    name: 'metaTitle',
    label: 'Tytuł meta',
    type: FormRenderTypes.input,
    value: '',
    placeholder: 'Tytuł meta hotelu',
    group: FormRenderGroupTypes.seo,
  },
  {
    name: 'metaDescription',
    label: 'Opis meta',
    type: FormRenderTypes.input,
    value: '',
    placeholder: 'Opis meta hotelu',
    group: FormRenderGroupTypes.seo,
  },
  {
    name: 'metaKeywords',
    label: 'Słowa kluczowe meta',
    type: FormRenderTypes.input,
    value: '',
    placeholder: 'Słowa kluczowe meta hotelu',
    group: FormRenderGroupTypes.seo,
  },
  {
    name: 'street',
    label: 'Ulica',
    type: FormRenderTypes.input,
    value: '',
    placeholder: 'Wprowadź ulicę hotelu',
    group: FormRenderGroupTypes.address,
  },
  {
    name: 'city',
    label: 'Miasto',
    type: FormRenderTypes.input,
    value: '',
    placeholder: 'Wprowadź miasto hotelu',
    group: FormRenderGroupTypes.address,
  },
  {
    name: 'postalCode',
    label: 'Kod pocztowy',
    type: FormRenderTypes.input,
    value: '',
    placeholder: 'Wprowadź kod pocztowy hotelu',
    group: FormRenderGroupTypes.address,
  },

  {
    name: 'published',
    label: 'Opublikowany',
    type: FormRenderTypes.switch,
    value: '',
    group: FormRenderGroupTypes.configuration,
  },
  {
    name: 'displayOrder',
    label: 'Kolejność wyświetlania',
    type: FormRenderTypes.number,
    value: '',
    placeholder: 'Kolejność wyświetlania hotelu',
    group: FormRenderGroupTypes.configuration,
  },
];
